import React, { useEffect, useState, useReducer } from "react";
import "./App.css";
import Navigation from "./components/Navigation";
import Constants from "./constants/Constants";
import ModelArchive from "./components/ModelArchive";
import PremiumExplained from "./components/PremiumExplained";
import Video from "./components/Video";
import ModelDirectory from "./components/ModelDirectory";
import Header from "./components/desktop/Header";
import Subscriptions from "./components/Subscriptions";
import Loadable from "react-loadable";
import Profile from "./components/Profile";
import Tagged from "./components/Tagged";
import UpdateInfo from "./components/UpdateInfo";
import DM from "./components/DM";
import Conversation from "./components/Conversation";
import SitesContext from "./context/sites.context";
import UserContext from "./context/users.context";
import Loader from "./components/Loader";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { Router, Location, Redirect, navigate } from "@reach/router";
import Login from "./components/Login";
const isDesktop = window.innerWidth > 780 ? true : false;

const FadeTransitionRouter = (props) => (
  <Location>
    {({ location }) => (
      <TransitionGroup className="startRoute">
        <CSSTransition key={location.key} classNames="fade" timeout={500}>
          {/* the only difference between a router animation and
              any other animation is that you have to pass the
              location to the router so the old screen renders
              the "old location" */}
          <Router
            location={location}
            className="router"
            primary={isDesktop ? false : true}
          >
            {props.children}
          </Router>
        </CSSTransition>
      </TransitionGroup>
    )}
  </Location>
);
function shuffle(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}
function reducer(state, action) {
  switch (action.type) {
    case "init":
      return {
        user: shuffle(action.payload.subs),
        sites: action.payload.sites,
        biller: action.payload.biller,
        userInfo: {
          username: action.payload.user,
          favs: action.payload.favs,
          library: action.payload.library,
          unreadMsgs: parseInt(action.payload.unreadMsgs),
          avatar: action.payload.options.avatar,
          comment_name: action.payload.options.comment_name,
          is_nvg_member: action.payload.options.is_nvg_member,
        },
        force_update: action.payload.options.force_update,
        email_notifications: action.payload.options.email_notifications,
        push_notifications: action.payload.options.push_notifications,
        snapchat: action.payload.snapchat_name,
        loading: false,
        actives: action.payload.active,
        pos: 0,
        cacheBust: "stan",
        lastSlide: 0,
        scrollSite: "",
      };
    case "changeLogin":
      return { ...state, login: action.payload };
    case "lastSlide":
      return { ...state, lastSlide: action.payload };
    case "setMemToExpire":
      let AddTime = state.user[action.payload];
      AddTime.biller_expires = action.timeVal;
      return {
        ...state,
        user: Object.assign([], state.user, {
          [action.payload]: AddTime,
        }),
      };
    case "mailchecked":
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          unreadMsgs: 0,
        },
      };
    case "isnvgmember":
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          is_nvg_member: 9999,
        },
      };
    case "scrollTo":
      return { ...state, pos: action.payload, scrollSite: action.site };
    case "addMembership":
      let newActives = [...state.actives];
      let modelID = action.siteid;
      if (typeof modelID === "number") {
        modelID = modelID.toString();
      }
      if (!state.actives.includes(modelID)) {
        newActives.push(action.siteid);
      }
      return {
        ...state,
        user: [...state.user, action.payload],
        cacheBust: Date.now(),
        actives: [...newActives],
      };
    case "changeBothSnapchatAndComment":
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          comment_name: action.commentName,
        },
        force_update: "n",
        snapchat: action.snap,
      };
    case "changePushNotifications":
      return { ...state, push_notifications: action.payload };
    case "changeNotesEmail":
      return { ...state, email_notifications: action.payload };
    case "changeSnapChatName":
      return { ...state, snapchat: action.payload };
    case "changeCommentName":
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          comment_name: action.payload,
        },
        force_update: "n",
      };
    case "addFavorite":
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          favs: [...state.userInfo.favs, action.payload],
        },
      };
    case "addLibrary":
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          library: [...state.userInfo.library, action.payload],
        },
      };
    case "removeFavorite":
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          favs: state.userInfo.favs.filter((id) => id !== action.payload),
        },
      };
    default:
      throw new Error("dispatch with wrong type.");
  }
}
const initialState = {
  sites: [],
  user: [],
  userInfo: {
    username: "",
    favs: [],
    avatar: "",
    comment_name: "need_to_set",
    library: [],
    is_nvg_member: 0,
    unreadMsgs: 0,
  },
  force_update: "n",
  email_notifications: "y",
  push_notifications: "y",
  snapchat: "",
  loading: true,
  biller: "none",
  actives: [],
  lastSlide: 0,
  pos: 0,
  cacheBust: "stan",
  scrollSite: "",
  login: false,
};
const AsyncRiver = Loadable({
  loader: () => import("./components/RiverSlider"),
  loading: Loader,
});
const AsyncRiverDesktop = Loadable({
  loader: () => import("./components/desktop/River"),
  loading: Loader,
});
const AsyncFooter = Loadable({
  loader: () => import("./components/desktop/Footer"),
  loading() {
    return null;
  },
});
function App() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [showFilters, setShowFilters] = useState(false);

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };
  const attemptToLogin = () => {
    fetch(`${Constants.API}user-init.php`, {
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 401 || res.status === 403) {
          //redirect to login...
          navigate(`${Constants.MA}login`);
          dispatch({ type: "changeLogin", payload: true });
          return false;
        }
        return res.json();
      })
      .then(
        (res) => {
          if (typeof res === "boolean") {
            return;
          }
          dispatch({ type: "init", payload: res });
          if (res.options.force_update === "y") {
            navigate(`${Constants.MA}update-info`);
          }
        },
        (error) => {
          // console.log("there was an error", error);
          // window.location.href =
          //   "https://addfriends.com/reset/?cb=" + Date.now();
        }
      );
  };
  useEffect(() => {
    fetch(`${Constants.API}user-init.php`, {
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 401 || res.status === 403) {
          //redirect to login...
          navigate(`${Constants.MA}login`);
          dispatch({ type: "changeLogin", payload: true });
          return false;
        }
        return res.json();
      })
      .then(
        (res) => {
          if (typeof res === "boolean") {
            return;
          }
          dispatch({ type: "init", payload: res });
          if (res.options.force_update === "y") {
            navigate(`${Constants.MA}update-info`);
          }
        },
        (error) => {
          navigate(`${Constants.MA}login`);
          dispatch({ type: "changeLogin", payload: true });
          return false;
          // console.log("there was an error", error);
          // window.location.href =
          //   "https://addfriends.com/reset/?cb=" + Date.now();
        }
      );
  }, []);

  if (state.login) {
    //we will return login thing here..
    return <Login attemptToLogin={attemptToLogin} />;
  }
  if (state.loading) {
    return <Loader />;
  }

  return (
    <div
      className={
        isDesktop ? "wrapper_mobile wrapper_general" : "wrapper_mobile"
      }
    >
      {isDesktop ? (
        <Header
          userInfo={state.userInfo}
          snapchat={state.snapchat}
          toggleFilters={toggleFilters}
          showFilters={showFilters}
          unreadMsgs={state.userInfo.unreadMsgs}
          search={state.sites}
        />
      ) : null}
      <SitesContext.Provider value={state.sites}>
        <UserContext.Provider value={state.user}>
          <FadeTransitionRouter>
            {state.force_update === "y" ? null : (
              <Redirect
                from={Constants.MA}
                to={`${Constants.MA}subscriptions`}
                noThrow
              />
            )}

            <Subscriptions
              path={`${Constants.MA}subscriptions`}
              dispatch={dispatch}
              biller={state.biller}
            />
            <UpdateInfo
              path={`${Constants.MA}update-info`}
              snapchat={state.snapchat}
              dispatch={dispatch}
            />
            {isDesktop ? (
              <AsyncRiverDesktop
                path={`${Constants.MA}af-now`}
                showFilters={showFilters}
                dispatch={dispatch}
                biller={state.biller}
                pageStart={state.lastSlide}
                avatar={state.userInfo.avatar}
                commentName={state.userInfo.comment_name}
              />
            ) : (
              <AsyncRiver
                path={`${Constants.MA}af-now`}
                actives={state.actives}
                lastSlide={state.lastSlide}
                dispatch={dispatch}
                biller={state.biller}
                avatar={state.userInfo.avatar}
              />
            )}
            <Profile
              path={`${Constants.MA}profile`}
              username={state.userInfo.username}
              ogCommentName={state.userInfo.comment_name}
              snapchat={state.snapchat}
              email={state.email_notifications}
              push={state.push_notifications}
              dispatch={dispatch}
            />
            <PremiumExplained path={`${Constants.MA}what-is-premium`} />
            <Conversation
              path={`${Constants.MA}messages/:siteid`}
              isDesktop={isDesktop}
              biller={state.biller}
              dispatch={dispatch}
            />
            <DM
              path={`${Constants.MA}messages`}
              dispatch={dispatch}
              actives={state.actives}
              allSites={state.sites}
            />
            <ModelDirectory path={`${Constants.MA}friends`} />
            <Tagged
              path={`${Constants.MA}tagged/:tagName`}
              dispatch={dispatch}
              biller={state.biller}
              pos={state.pos}
              actives={state.actives}
              scrollSite={state.scrollSite}
              allSites={state.sites}
            />
            <ModelArchive
              path={`${Constants.MA}:modelName`}
              biller={state.biller}
              dispatch={dispatch}
              pos={state.pos}
              actives={state.actives}
              scrollSite={state.scrollSite}
              avatar={state.userInfo.avatar}
              library={state.userInfo.library}
              nvgMember={state.userInfo.is_nvg_member}
            />

            <Video
              path={`${Constants.MA}video/:id`}
              dispatch={dispatch}
              className="slide"
              biller={state.biller}
              favs={state.userInfo.favs}
              library={state.userInfo.library}
              cacheBust={state.cacheBust}
              avatar={state.userInfo.avatar}
            />
          </FadeTransitionRouter>
        </UserContext.Provider>
      </SitesContext.Provider>
      {isDesktop ? (
        <AsyncFooter />
      ) : (
        <Navigation unreadMsgs={state.userInfo.unreadMsgs} />
      )}
    </div>
  );
}

export default App;
